export default __webpack_public_path__ + "static/media/Wpelevation.69ed2d3c.png";